<body>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
          <div class="card card-signin my-5">
            <div class="card-body">
              <p  class="card-title text-center"><strong>Punjab Building and Other Construction Workers Welfare Board</strong></p>
              <p class=" text-center"><small>Enter Username and click on forgot.</small></p>
              <div class="align-middle">
                  <img class="rounded mx-auto d-block" src="{{assestBase}}assets/pblogo.png">
              </div>
              <form class="form-signin mt-4" >

                  <div class="col-md-12">
                      <mat-label>Enter username</mat-label>
                      <mat-form-field class="full-width" appearance="outline">
                        <input matInput placeholder="Enter username" [(ngModel)]="username" [ngModelOptions]="{standalone: true}">
                      </mat-form-field>
                    </div>
                  <div class="col-md-12" *ngIf="isUserFound==true">
                        <mat-label>Enter your mobile no end with <b><i>XXXXX-X{{userdata.mobile}}</i></b></mat-label>
                      <mat-form-field class="full-width" appearance="outline">
                          <input matInput placeholder="Enter your phone no." [(ngModel)]="mobile" [ngModelOptions]="{standalone: true}">
                      </mat-form-field>
                    </div>
                    <button class="btn btn-lg btn-info btn-block text-uppercase" *ngIf="isUserFound!=true" (click)="findUser()">Forgot</button>
                    <button class="btn btn-lg btn-info btn-block text-uppercase" *ngIf="isUserFound==true" (click)="sendOTP()">send OTP</button>
               <!--  <button class="btn btn-lg btn-info btn-block text-uppercase"  data-toggle="modal" data-target="#changePassword">Send OTP</button> -->

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>


  <!-- The Modal -->
<div class="modal" id="changePassword">
    <div class="modal-dialog">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Change Password</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>


        <!-- Modal body -->
        <div class="modal-body">
          <form class="form">
            <div class="col-md-12">
              <p>An <b>OTP</b> is sent on (+91-XXXXX-X{{userdata.mobile}}) this number. Please enter in the given field</p>
            </div>
            <div class="col-md-12">
                <mat-label>Enter OTP</mat-label>
                <mat-form-field class="full-width" appearance="outline">
                  <input matInput placeholder="Enter OTP" [(ngModel)]="otp" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
                <mat-label>New Password</mat-label>
                <mat-form-field class="full-width" appearance="outline">
                  <input matInput placeholder="new Password" [(ngModel)]="newpass" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
                <mat-label>Confirm password</mat-label>
                <mat-form-field class="full-width" appearance="outline">
                  <input matInput placeholder="confirm password" [(ngModel)]="confirmpass" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
            </div>
          </form>
        </div>

        <!-- Modal footer -->
        <div class="modal-footer">

          <button type="button" class="btn btn-success" (click)="changePassword()" >Change Password</button>
        </div>

      </div>
    </div>
  </div>
